import {useDownloadFile} from 'hooks/use-download-file/use-download-file';
import {FC, memo, useCallback} from 'react';
import {machineClient} from 'state/api-clients';
import {AsyncOperationHandler} from 'utilities/platform-helpers/api-helper';
import {YYMMDDhhmm} from 'utilities/platform-helpers/date-helpers';
import {DownloadExcelButton} from 'view/components/specific-components/buttons/download-excel-button';

export const DownloadMachineExcel: FC = memo(() => {
  const exportMachineOverview = useCallback(async () => {
    return await AsyncOperationHandler(() => machineClient.exportMachineOverview());
  }, []);

  const namePostfix = () => {
    return `-${YYMMDDhhmm(new Date())}`;
  };

  const {ref, url, download, name, isLoading} = useDownloadFile({
    apiDefinition: exportMachineOverview,
    namePostfix: namePostfix,
  });

  return <DownloadExcelButton isLoading={isLoading} name={name} url={url} download={download} reference={ref} />;
});
